'use client';

import { Typography } from '@bgzt/ui';
import { Button } from '@bgzt/ui';
import { LinkByEnvironment, ProductListTemp, ProductItem, Spacing } from '~/components';

import { ProductDataV2 } from '~/apis/search';
import { ShopId, VALID_SHOP_IDS } from '~/constants/shop';
import { getShopInfo } from '~/utils/shop-service';

type Props = {
  shopId?: string;
  shopProducts?: ProductDataV2[];
};
export const ShopMoreProducts = ({ shopId, shopProducts }: Props) => {
  if (!shopId || !VALID_SHOP_IDS.includes(shopId as ShopId) || shopProducts?.length === 0) return null;

  return (
    <>
      <Spacing height={20} />
      <Typography variant="S1" color="gray-900">
        {getShopInfo(shopId as ShopId).shopNameKor} 상품 더보기
      </Typography>
      <Spacing height={12} />
      <ProductListTemp col={3}>
        {shopProducts?.map((product) => {
          const path = `/products/${product.pid}`;
          return (
            <li key={product.pid}>
              <LinkByEnvironment href={path} target={'_self'}>
                <ProductItem
                  pid={Number(product.pid)}
                  image={product.productImage}
                  name={product.name}
                  location={product.location}
                  updatedBefore={product.updatedBefore}
                  price={product.price}
                  status={'SELLING'}
                  faved={product.faved}
                  discountRate={product.discount?.rate}
                  viewType="3-column"
                />
              </LinkByEnvironment>
            </li>
          );
        })}
      </ProductListTemp>
      <Spacing height={20} />
      <LinkByEnvironment href={`/shop/${shopId}`} target={'_blank'}>
        <Button variant="normalGray" size="large" width={'100%'}>
          상품 전체보기
        </Button>
      </LinkByEnvironment>
    </>
  );
};
